"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_theme_provider_1 = require("@gooddata/sdk-ui-theme-provider");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importDefault(require("react"));
var aggregationsMenuHelper_1 = tslib_1.__importDefault(require("./aggregationsMenuHelper"));
var MENU_HEADER_OFFSET = -36;
var HeaderIcon = function () {
    var _a, _b, _c, _d;
    var theme = sdk_ui_theme_provider_1.useTheme();
    return (react_1.default.createElement("div", { className: "gd-aggregation-submenu-header-icon" },
        react_1.default.createElement(sdk_ui_kit_1.Icon.Rows, { width: 12, height: 11, colorPalette: {
                even: (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _a === void 0 ? void 0 : _a.complementary) === null || _b === void 0 ? void 0 : _b.c7,
                odd: (_d = (_c = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _c === void 0 ? void 0 : _c.complementary) === null || _d === void 0 ? void 0 : _d.c4,
            } })));
};
var AggregationsSubMenu = /** @class */ (function (_super) {
    tslib_1.__extends(AggregationsSubMenu, _super);
    function AggregationsSubMenu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AggregationsSubMenu.prototype.render = function () {
        var _a = this.props, toggler = _a.toggler, isMenuOpened = _a.isMenuOpened, intl = _a.intl;
        var menuOpenedProp = isMenuOpened ? { opened: true } : {};
        return (react_1.default.createElement(sdk_ui_kit_1.SubMenu, tslib_1.__assign({ toggler: toggler, offset: MENU_HEADER_OFFSET }, menuOpenedProp),
            react_1.default.createElement(sdk_ui_kit_1.ItemsWrapper, null,
                react_1.default.createElement("div", { className: "gd-aggregation-submenu s-table-header-submenu-content" },
                    react_1.default.createElement(sdk_ui_kit_1.Header, null,
                        react_1.default.createElement(HeaderIcon, null),
                        react_1.default.createElement("span", null, intl.formatMessage({ id: "visualizations.menu.aggregations.rows" }))),
                    this.renderSubMenuItems()))));
    };
    AggregationsSubMenu.prototype.getPreviousAttributeName = function (rowAttributeDescriptors, attributeHeaderIndex) {
        return sdk_model_1.attributeDescriptorName(rowAttributeDescriptors[attributeHeaderIndex - 1]);
    };
    AggregationsSubMenu.prototype.getAttributeName = function (rowAttributeDescriptors, afmAttributeHeaderIndex) {
        var intl = this.props.intl;
        if (afmAttributeHeaderIndex === 0) {
            return intl.formatMessage({ id: "visualizations.menu.aggregations.all-rows" });
        }
        var attributeName = this.getPreviousAttributeName(rowAttributeDescriptors, afmAttributeHeaderIndex);
        return intl.formatMessage({ id: "visualizations.menu.aggregations.within-attribute" }, { attributeName: attributeName });
    };
    AggregationsSubMenu.prototype.getSubtotalNameTestClass = function (attributeLocalIdentifier) {
        var attributeClass = attributeLocalIdentifier.replace(/\./g, "-");
        return "s-aggregation-item-" + attributeClass;
    };
    AggregationsSubMenu.prototype.renderSubMenuItems = function () {
        var _this = this;
        var _a = this.props, totalType = _a.totalType, rowAttributeDescriptors = _a.rowAttributeDescriptors, measureLocalIdentifiers = _a.measureLocalIdentifiers, columnTotals = _a.columnTotals;
        return rowAttributeDescriptors.map(function (_attributeDescriptor, headerIndex) {
            var attributeLocalIdentifier = sdk_model_1.attributeDescriptorLocalId(rowAttributeDescriptors[headerIndex]);
            var isSelected = aggregationsMenuHelper_1.default.isTotalEnabledForAttribute(attributeLocalIdentifier, totalType, columnTotals);
            var onClick = function () {
                return _this.props.onAggregationSelect({
                    type: totalType,
                    measureIdentifiers: measureLocalIdentifiers,
                    include: !isSelected,
                    attributeIdentifier: attributeLocalIdentifier,
                });
            };
            var attributeName = _this.getAttributeName(rowAttributeDescriptors, headerIndex);
            return (react_1.default.createElement(sdk_ui_kit_1.Item, { checked: isSelected, key: attributeLocalIdentifier },
                react_1.default.createElement("div", { onClick: onClick, className: classnames_1.default("gd-aggregation-menu-item-inner", "s-menu-aggregation-inner", _this.getSubtotalNameTestClass(attributeLocalIdentifier), {
                        "s-menu-aggregation-inner-selected": isSelected,
                    }) }, attributeName)));
        });
    };
    AggregationsSubMenu.defaultProps = {
        isMenuOpened: false,
    };
    return AggregationsSubMenu;
}(react_1.default.Component));
exports.default = AggregationsSubMenu;
//# sourceMappingURL=AggregationsSubMenu.js.map